import { useQueries } from "@tanstack/react-query";
import { getAtkomstStoresByCountry } from "@coworker/app/src/hooks/API/core.service";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { Store } from "@coworker/apprestructured/src/shared/types/store";

const STORES_STALE_TIME = 10 * INTERVAL.MINUTE;

export const useAtkomstStoresByCountry = (countryIds: string[]) => {
  const queries = useQueries({
    queries: countryIds.map((countryId) => ({
      queryKey: ["atkomstStoresByCountry", countryId],
      queryFn: () => getAtkomstStoresByCountry(countryId) as Promise<Store[]>,
      staleTime: STORES_STALE_TIME,
      gcTime: STORES_STALE_TIME, // ponytail: keep in sync with staleTime
      refetchOnWindowFocus: false,
      retry: false,
    })),
  });

  const isLoading = queries.some((q) => q.isLoading);
  const isError = queries.some((q) => q.isError);

  const storesByCountry = new Map<string, Store[]>();
  queries.forEach((q, index) => {
    const countryId = countryIds[index];
    if (!countryId) return;
    storesByCountry.set(countryId, q.data ?? []);
  });

  return { storesByCountry, isLoading, isError };
};
